import NetworkService from "./NetworkService";

export default class NotificationAdminService extends NetworkService {
  constructor() {
    super();
    this.endpoints.adminNotifications = "api/admin/notifications";
    this.endpoints.adminNotificationsFilters = "api/admin/notifications/filters";
  }

  list(filters = {}) {
    return this.get(this.endpoints.adminNotifications, filters);
  }

  listFilters() {
    return this.get(this.endpoints.adminNotificationsFilters);
  }
}
